import { cn } from './utils';

export function KpiCard({
	label,
	value,
	className,
	valueClassName,
	subLabel
}: {
	label: string;
	value: number | string;
	className?: string;
	valueClassName?: string;
	subLabel?: string;
}) {
	return (
		<div className={cn('border border-l-4 border-gray-200 bg-white rounded-lg p-4', className)}>
			<div className="mb-1.5 text-xs font-medium uppercase tracking-wide text-gray-500">{label}</div>
			<div className={cn('text-2xl font-semibold', valueClassName)}>{value}</div>
			{subLabel && <div className="mt-0.5 text-xs text-gray-400">{subLabel}</div>}
		</div>
	);
}
